interface DescriptionFeature {
  type: string;
  value: string;
  icon?: string;
}

export function parseDescription(description: string | null | undefined): DescriptionFeature[] {
  if (!description) return [];

  const features: DescriptionFeature[] = [];
  const text = description.toLowerCase();

  // Características principais em descrições de imóveis
  const patterns = [
    {
      type: 'mobilia',
      regex: /(armários planejados|móveis planejados|cozinha planejada|closet)/,
      value: (match: string) => {
        if (match.includes('cozinha')) return 'Cozinha planejada';
        if (match.includes('closet')) return 'Closet';
        return 'Armários planejados';
      }
    },
    {
      type: 'tecnologia',
      regex: /(energia solar|painel solar|aquecedor solar|sistema fotovoltaico)/,
      value: (match: string) => {
        if (match.includes('aquecedor')) return 'Aquecedor';
        return 'Energia solar';
      }
    },
    {
      type: 'lazer',
      regex: /(piscina|academia|sauna|churrasqueira|área de lazer)/i,
      value: (match: string) => match.charAt(0).toUpperCase() + match.slice(1)
    },
    {
      type: 'ambiente',
      regex: /(escritório|home office|condomínio completo)/,
      value: (match: string) => {
        if (match.includes('condomínio')) return 'Condomínio completo';
        if (match.includes('home')) return 'Home office';
        return 'Escritório';
      }
    },
    {
      type: 'caracteristica',
      regex: /(esquina|novo|lançamento)/,
      value: (match: string) => match.charAt(0).toUpperCase() + match.slice(1)
    },
    {
      type: 'financiamento',
      regex: /(aceita financiamento|financiamento)/,
      value: () => 'Aceita financiamento'
    }
  ];

  // Procurar por cada padrão no texto e permitir múltiplas ocorrências
  patterns.forEach(pattern => {
    const matches = text.match(new RegExp(pattern.regex, 'gi')) || [];
    const uniqueMatches = new Set(matches); // Remove duplicatas
    
    uniqueMatches.forEach(match => {
      const value = typeof pattern.value === 'function' 
        ? pattern.value(match)
        : pattern.value;
      
      // Evitar duplicatas de valores também
      if (!features.some(f => f.value === value)) {
        features.push({
          type: pattern.type,
          value: value
        });
      }
    });
  });

  return features;
} 